import { formatDeadline } from './format';

/**
 * «Última actualización en la fuente» — the date the SOURCE says it last updated
 * this record (MiLicita, `es`).
 *
 * The reuse conditions of the PLACSP open data (Ministerio de Hacienda) ask the
 * reuser to state the date of the documents' last update wherever the original
 * gives one. PLACSP gives it on every ATOM entry as `<updated>`, which the
 * adapter stores verbatim — with its Madrid offset — as `procedure.feedUpdated`
 * (`placsp.parse.ts`, `mapPlacspEntry`).
 *
 * The calendar date is read in the stamp's OWN offset: `2026-10-17T00:30+02:00`
 * is 17 October in Madrid, even though it is still the 16th in UTC, where
 * `formatDeadline` would otherwise put it.
 *
 * `null` when the record carries no such stamp (no UZ/KZ source writes one) or
 * it is not an ISO date-time — then the card simply has no row.
 */
export function sourceUpdatedDate(
  procedure: Record<string, unknown> | null | undefined,
  locale: string,
): string | null {
  const raw = procedure?.feedUpdated;
  if (typeof raw !== 'string') return null;
  const stamp = raw.trim();
  const day = /^(\d{4}-\d{2}-\d{2})T/.exec(stamp)?.[1];
  if (!day || Number.isNaN(Date.parse(stamp))) return null;
  return formatDeadline(day, locale);
}
